import { useState } from 'react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { getEnvelopeSignLink } from '../../../../models/esign'

interface EnvelopeSignLinkButtonProps {
  orgId: string
  envelopeId: string
}

export function EnvelopeSignLinkButton({ orgId, envelopeId }: EnvelopeSignLinkButtonProps) {
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    setLoading(true)
    try {
      const { link } = await getEnvelopeSignLink(orgId, envelopeId)
      await navigator.clipboard.writeText(link)
      toast.success('Sign link copied to clipboard')
    } catch {
      toast.error('Failed to get sign link. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      disabled={loading}
      loading={loading ? 'Copying...' : undefined}
    >
      Copy sign link
    </Button>
  )
}
